<template>
  <section>
    <left-menu />

    <div id="mainContent" class="list-fit-content">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{pgTitle}}</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <!-- Box Filter -->
          <div class="col-xs-12 col-sm-12 col-md-12 default-box filter-box">
            <!-- Values -->
              <form name="form" novalidate>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <h2 class="certa filter-title">Filtros</h2>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20 padding-null">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-with-date">
                      <label>Data Inicial</label>
                      <datepicker ref="programaticOpen1" v-model="initialDate" :language="ptBR" :format="customFormatter"/>
                      <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-with-date">
                      <label>Data Final</label>
                      <datepicker ref="programaticOpen2" v-model="finalDate" :language="ptBR" :format="customFormatter"/>
                      <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                    </div>
                  </div>

                  <div v-if="!onlyMyRequest" class="col-xs-12 col-sm-6 col-md-3">
                    <label>Pesquise por funcionário</label>
                    <autocomplete
                            id="myAutocomplete"
                            anchor="name"
                            label="writer"
                            placeholder="Nome do funcionário"
                            v-bind:url="urlSearchEmp"
                            v-model="userSelected"
                            :customHeaders="{Authorization: 'bearer ' + bearerAutoComplete, Contentsetting: this.contentSetting}"
                            :min="1"
                            :debounce="500"
                            :onAjaxProgress="callbackEvent"
                            :onAjaxLoaded="callbackEvent"
                            :on-select="getDataSelected">
                    </autocomplete>
                    <img v-if="isSearchWithUser" v-on:click="reloadEmployers()" src="../../../../assets/img/fail_send.png" class="img-responsive remove-user2"/>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="select-input">
                      <label>Situação</label>
                      <select v-model="statusSelected">
                        <option value="">Todos</option>
                        <option value="1">Solicitado</option>
                        <option value="2">Aprovado</option>
                        <option value="3">Reprovado</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="!onlyMyRequest" class="col-xs-12 col-sm-12 col-md-12 offset-top-20 padding-null">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="select-input">
                      <label>Motivo</label>
                      <select v-model="motiveSelected">
                        <option value="">Todos</option>
                        <option value="esqueci de registrar">Esqueci de Registrar</option>
                        <option value="sem internet no momento registrar">Sem internet no momento registrar</option>
                        <option value="férias">Férias</option>
                        <option value="afastamento">Afastamento</option>
                        <option value="atestado médico">Atestado Médico</option>
                        <option value="inss">INSS</option>
                        <option value="treinamento">Treinamento</option>
                        <option value="licença maternidade">Licença Maternidade</option>
                        <option value="licença paternidade">Licença Paternidade</option>
                        <option value="licença">Licença</option>
                        <option value="happy day">Happy Day</option>
                        <option value="justiça">Justiça</option>
                        <option value="férias coletivas">Férias Coletivas</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="select-input">
                      <label>Equipe</label>
                      <select v-model="teamSelected">
                        <option value="">Todos</option>
                        <option v-for="t in allTeam" :value="t.id" :key="t.id">{{ t.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="select-input">
                      <label>Cargo</label>
                      <select v-model="officeSelected">
                        <option value="">Todos</option>
                        <option v-for="t in allOffice" :value="t.id" :key="t.id">{{ t.nameMale }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="select-input">
                      <label>Turno</label>
                      <select v-model="workShiftSelected">
                        <option value="">Todos</option>
                        <option v-for="t in allWorkShift" :value="t.id" :key="t.id">{{ t.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <button class="btn-search-fit" v-on:click="searchRequestDate()" type="button">Pesquisar</button>
                </div>
              </form>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-list-fit">
            <div class="infos">
              <h2 class="certa">Lista de solicitações</h2>
              <p class="nunito txt-help" v-if="message">{{message}}</p>
            </div>

            <!-- Loading -->
            <div v-if="loading" class="loader-page-content">
              <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>

            <div v-if="allRequest.length" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
              <div class="table-responsive table-clean">
                <table class="table">
                  <thead>
                  <tr>
                    <th class="certa no-wrap">Código</th>
                    <th class="certa no-wrap">Nome</th>
                    <th class="certa no-wrap">Data</th>
                    <th class="certa no-wrap">Situação</th>
                    <th class="certa no-wrap">Motivo</th>
                    <th class="certa no-wrap">Tipo de solicitação</th>
                    <th class="certa no-wrap">Responsável</th>
                    <th class="certa no-wrap">Visualizar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="r in allRequest">
                    <td>
                      <p class="offset-top-20 nunito">#{{r.userCode}}</p>
                    </td>
                    <td>
                      <a target="_blank" v-bind:href="'/perfil/3/' + r.uId" class="link2">{{r.userName}}</a>
                    </td>
                    <td>
                      <p>{{r.pointReference | convertToDayMothYear}}</p>
                    </td>
                    <td>
                        <p v-if="r.userPointAdjustmentStatus === 1" class="status-incorrect"> Solicitado</p>
                        <p v-if="r.userPointAdjustmentStatus === 2" class="status-done">Aprovado</p>
                        <p v-if="r.userPointAdjustmentStatus === 3" class="status-fault">Reprovado</p>
                    </td>
                    <td>
                      <p class="nunito">{{r.reason}}</p>
                    </td>
                    <td>
                      <p v-if="r.userPointAdjustmentType === 1"><span>Ajuste</span></p>
                      <p v-if="r.userPointAdjustmentType === 2"><span>Abono</span></p>
                      <p v-if="r.userPointAdjustmentType === 3"><span>Abono Parcial</span></p>
                    </td>
                    <td>
                      <p class="nunito">{{r.responsibleName}}</p>
                    </td>
                    <td>
                      <a v-if="!onlyMyRequest" v-bind:href="'/verificar-ajuste-solicitado/' + r.id" title="Visualizar solicitação de ajuste" target="_blank" class="link nunito">Visualizar solicitação</a>
                      <a v-if="onlyMyRequest" v-bind:href="'/detalhe-do-ponto/' + r.id + '/' + 6" title="Visualizar detalhe do ponto" target="_blank" class="link nunito">Visualizar detalhe do ponto</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <mugen-scroll :handler="getMore" :should-handle="!loadingMore">
                <!-- Loading -->
                <div v-if="loadingMore" class="loader-page-content">
                  <div class="spinner">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </mugen-scroll>
            </div>

            <div v-if="!loading && !allRequest.length && !loadingMore && !isSearch && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">Nenhuma solicitação encontrada.</p>
            </div>

            <div v-if="!loading && !allRequest.length && !loadingMore && failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">{{msgError}}</p>
            </div>

            <div v-if="!loading && !allRequest.length && !loadingMore && isSearch && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">Nenhum solicitação encontrada na pesquisa.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue'
  import vueFooter from "../../components/footer";
  import fullLoading from "../../components/blueFullLoading";
  import datepicker from 'vuejs-datepicker';
  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import moment from 'moment';
  import MugenScroll from 'vue-mugen-scroll';
  import swal from 'sweetalert';
  import Autocomplete from 'vue2-autocomplete-js'
  import { required } from 'vuelidate/lib/validators';

  import { GET_LIST_SOLICITATION, REPORT_SOLICITATIONS, ALL_WORK_SHIFT, ALL_TEAM, ALL_OFFICE, SEARCH_EMPLY } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";

  export default {
    name: 'list-fit',
    components: {
      fullLoading,
      leftMenu,
      vueFooter,
      datepicker,
      Autocomplete,
      MugenScroll
    },
    data() {
      return {
        onlyMyRequest: false,
        pgTitle: '',
        isSearch: false,
        msgError: '',
        ptBR: ptBR,
        loading: false,
        isSearchWithUser: false,
        loadingMore: false,
        failRequest: false,
        haveMore: true,
        initialDate: new Date().setDate(new Date().getDate() - 15),
        finalDate: new Date(),
        allTeam: [],
        allWorkShift: [],
        allOffice: [],
        statusSelected: '',
        motiveSelected: '',
        teamSelected: '',
        officeSelected: '',
        workShiftSelected: '',
        message: '',
        allRequest: [],
        pageNumber: 1,
        itemsPerPage: 25,
        userSelected: '',
        urlSearchEmp: SEARCH_EMPLY,
        bearerAutoComplete: JSON.parse(window.localStorage.getItem('authUser')).userToken,
        contentSetting: JSON.parse(window.localStorage.getItem('authUser')).userContentSetting,
      }
    },
    methods: {
      callbackEvent(value) {

      },
      openCalendar1: function () {
        this.$refs.programaticOpen1.showCalendar();
      },
      openCalendar2: function () {
        this.$refs.programaticOpen2.showCalendar();
      },
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      searchRequestDate() {
        this.isSearch = true;
        this.message = '';
        this.allRequest = [];

        this.getSolicitation();
      },
      getMore() {
        if (this.allRequest.length && this.haveMore) {
          this.loadingMore = true;
          this.pageNumber++;
          this.getSolicitation();
        }
      },
      getSolicitation() {
        this.loading = true;
        this.failRequest = false;

        let obj = {
          i: JSON.parse(window.localStorage.getItem('userInfo')).id,
          initDate: moment(this.initialDate).format("YYYY-MM-DD"),
          endDate: moment(this.finalDate).format("YYYY-MM-DD"),
          pageQtd: this.itemsPerPage,
          pageNumber: this.pageNumber,
          status: 0
        };

        if (this.statusSelected)
          obj.status = this.statusSelected;

        if (this.motiveSelected)
          obj.motive = this.motiveSelected;

        if (this.teamSelected)
          obj.teamId = this.teamSelected;

        if (this.officeSelected)
          obj.officeId = this.officeSelected;

        if (this.workShiftSelected)
          obj.workShiftId = this.workShiftSelected;

        if (this.userSelected.id)
          obj.u = this.userSelected.id;

        UTIL_SERVICE.console("OBJ URL:", obj);
        REQUEST_SERVICE.post(REPORT_SOLICITATIONS, obj).then((response) => {
          UTIL_SERVICE.console("RESULT GET_LIST_SOLICITATION:", response.data);

          this.message = response.data.message;
          if (response.data.list.length) {
            response.data.list.map((value, index) => {
              this.allRequest.push(value);
            });

            if (response.data.list.length < 25)
              this.haveMore = false;

          } else {
            this.haveMore = false;
          }

          this.loadingMore = false;
          this.loading = false;
        }).catch(reason => {

          try {
            if (reason.response.data.erros.length) {
              this.msgError = reason.response.data.erros[0].value;
            } else {
              this.msgError = 'Tivemos um problema com a conexão. Tente novamente atualizando a página.';
            }
          } catch (e) {
            this.msgError = 'Tivemos um problema com a conexão. Tente novamente atualizando a página.';
          }

          this.loadingMore = false;
          this.loading = false;
          this.failRequest = true;
        });
      },
      getWs() {
        REQUEST_SERVICE.get(ALL_WORK_SHIFT + "?i=" + this.userInfo.companyId).then((response) => {
            UTIL_SERVICE.console("RESULT ALL_WORK_SHIFT:", response);
            this.allWorkShift = response.data;

          }).catch(reason => {

        });
      },
      getOffice() {
        REQUEST_SERVICE.get(ALL_OFFICE + "?i=" + this.userInfo.companyId).then((response) => {
            UTIL_SERVICE.console("RESULT ALL_OFFICE:", response);
            this.allOffice = response.data;

            this.getWs();
          }).catch(reason => {
            this.getWs();
        });
      },
      getTeam() {
        REQUEST_SERVICE.get(ALL_TEAM + "?i=" + this.userInfo.companyId).then((response) => {
            UTIL_SERVICE.console("RESULT ALL_TEAM:", response);
            this.allTeam = response.data;

            this.getOffice();
          }).catch(reason => {
            this.getOffice();
        });
      },
      getDataSelected(obj){
        if (obj.name && obj.id) {
          this.userSelected = obj;
          this.isSearchWithUser = true;
        }
      },
      reloadEmployers() {
        $('#myAutocomplete').val('');
        this.userSelected = '';
        this.isSearchWithUser = false;
      }
    },
    beforeMount(){
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));

      if (window.location.pathname.includes("minhas-solicitacoes")) {
        this.pgTitle = "Minhas Solicitações";
        this.onlyMyRequest = true;

        this.getSolicitation();
      } else {
        this.pgTitle = "Solicitações";
        this.onlyMyRequest = false;

        this.getSolicitation();
        this.getTeam();
      }
    },
    validations: {
      dataStatus: {
        disapprovedReason: {
          required
        }
      },
      checkRadio: {
        required
      }
    },
  }
</script>


<style lang="scss">
  .box-list-fit {
    .result-list-table {
      background: #fff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
      padding: 40px 40px 20px 40px;
      -webkit-border-radius: 4px !important;
      -moz-border-radius: 4px !important;
      border-radius: 4px !important;
      margin-bottom: 80px;

      .content-title {
        font-size: 15px;
        font-weight: 600;
        color: #7b7878;
        border-bottom: 1px solid #7b7878;
        float: right;
        margin-bottom: 30px;
        margin-top: 0;
      }

      blockquote {
        padding: 0 20px;
        margin: 0 0 30px;
        border-left: 5px solid #7b7878;

        p {
          font-size: 15px;
          font-weight: 600;
          color: #7b7878;
          margin: 0 0 6px;
        }
      }

      .success-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 14px;
        border-radius: 4px !important;
        background-color: #00a651;
        font-weight: 600;
        position: relative;
        top: 7px;
      }

      .incorrect-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 18px;
        font-weight: 600;
        border-radius: 4px !important;
        background-color: #e74a4e;
        position: relative;
        top: 7px;
      }
      table {
        .checkbox {
          text-align: center;
        }

        .link {
          color: #3598dc;
          top: 0;
          border-bottom: 1px solid #3598dc;
          cursor: pointer;

          &:hover, &:focus, &:active {
            font-weight: normal;
            text-decoration: none;
            color: #0F77AE;
            border-bottom: 1px dashed #0F77AE;
          }
        }

        thead {
          tr {
            th {
              i {
                margin-left: 5px;
              }
            }
          }
        }

        tbody {
          td {
            ul {
              display: block;
              margin: 0;
              padding: 0;

              li {
                display: inline-block;
                vertical-align: top;
                list-style: none;
                }
            }
          }
        }
      }

      h2 {
        color: #3598dc;
        font-size: 20px;
        margin-bottom: 40px;
        font-weight: 400;
        letter-spacing: 1px;
        border-bottom: 1px solid #3598dc;
        padding-bottom: 13px;
        margin-top: 0;
      }
    }

    .content-empty {
      min-height: 300px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        font-size: 20px;
        text-transform: uppercase;
        text-align: center;
        font-weight: 600;
        letter-spacing: 1px;
      }
    }
  }

  .transition, .autocomplete, .showAll-transition, .autocomplete ul, .autocomplete ul li a{
    transition:all 0.3s ease-out;
    -moz-transition:all 0.3s ease-out;
    -webkit-transition:all 0.3s ease-out;
    -o-transition:all 0.3s ease-out;
  }

  .autocomplete ul{
    z-index: 1;
    font-family: "Montserrat", sans-serif;
    position: absolute;
    list-style: none;
    padding: 10px 0;
    display: inline-block;
    min-width: 15%;
    margin: 10px 0 0;
    width: 90%;
  }

  .autocomplete ul:before{
    content: "";
    display: block;
    position: absolute;
    height: 0;
    width: 0;
    border: 10px solid transparent;
    left: 46%;
    top: -20px
  }

  .autocomplete ul li a{
    text-decoration: none;
    display: block;
    padding: 10px 5px 5px 10px;

    b {
      font-weight: 600;
      letter-spacing: 1px;
    }
  }

  .autocomplete ul li a:hover, .autocomplete ul li.focus-list a{
  }

  .autocomplete ul li a span, /*backwards compat*/
  .autocomplete ul li a .autocomplete-anchor-label{
    display: block;
    margin-top: 3px;
    color: grey;
    font-size: 13px;
  }

  .autocomplete ul li a:hover .autocomplete-anchor-label,
  .autocomplete ul li.focus-list a span, /*backwards compat*/
  .autocomplete ul li a:hover .autocomplete-anchor-label,
  .autocomplete ul li.focus-list a span{ /*backwards compat*/
    color: white;
  }
  .remove-user2 {
    position: absolute;
    top: 32px;
    right: 73px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/requestedFit/listFit.vue